<template>
  <Head title="License Owner Registration" />
  <div class="estat-login owner-registration">
    <section class="estat-login-form">
      <div class="estat-login-brand">
        <Logo style="width: 170px; height: 84px;" />
      </div>
      <form @submit.prevent="submit">
        <p class="estat-eyebrow">WELCOME TO ESTAT</p>
        <h1>License Owner Registration</h1>
        <p class="estat-login-subtitle">Verify your license to submit energy generation reports.</p>
        <div v-if="$page.props.flash && $page.props.flash.success" class="registration-success" role="status" aria-live="polite">
          {{ $page.props.flash.success }}
        </div>
        <div class="registration-field">
          <label for="owner-license">License Number</label>
          <input id="owner-license" v-model.trim="form.license_no" type="text" required maxlength="191" autocomplete="off" placeholder="Enter your license number" :aria-invalid="!!form.errors.license_no" :aria-describedby="form.errors.license_no ? 'license-error' : undefined" />
          <p v-if="form.errors.license_no" id="license-error" class="registration-error" role="alert">{{ form.errors.license_no }}</p>
        </div>
        <div class="registration-field">
          <label for="owner-email">Registered Owner Email</label>
          <input id="owner-email" v-model.trim="form.email" type="email" required maxlength="50" autocomplete="email" autocapitalize="off" placeholder="Enter the email registered with ECoS" :aria-invalid="!!form.errors.email" :aria-describedby="form.errors.email ? 'email-error' : undefined" />
          <p v-if="form.errors.email" id="email-error" class="registration-error" role="alert">{{ form.errors.email }}</p>
        </div>
        <p class="registration-help">We will send a verification link to the registered owner email. The link is valid for <strong>24 hours</strong>.</p>
        <button class="btn-indigo estat-login-submit registration-submit" type="submit" :disabled="form.processing" :aria-busy="form.processing">
          <span v-if="form.processing" class="registration-spinner" aria-hidden="true"></span>
          {{ form.processing ? 'Checking License...' : 'Send Verification Link' }}
        </button>
        <p class="estat-login-register">Already have an account? <Link href="/login">Login to ESTAT</Link></p>
        <p class="registration-contact">If your registered email is missing or outdated, contact ECoS to update the license record.</p>
      </form>
    </section>
    <aside class="estat-login-visual">
      <div>
        <span class="estat-eyebrow">SABAH ENERGY DATA</span>
        <h2>Insights for a<br />sustainable future.</h2>
        <p>Collect, manage and explore Sabah’s energy statistics in one place.</p>
      </div>
    </aside>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'

export default {
  components: { Head, Link, Logo },
  data() {
    return { form: this.$inertia.form({ license_no: '', email: '' }) }
  },
  methods: {
    submit() {
      this.form.post('/owner/register', { preserveScroll: true })
    },
  },
}
</script>

<style scoped>
.owner-registration .estat-login-form { max-width: 510px; }
.owner-registration h1 { font-size: 30px; line-height: 1.25; }
.owner-registration .estat-login-subtitle { margin-top: 10px; line-height: 1.6; }
.registration-field { margin-top: 24px; }
.registration-field label { display: block; margin-bottom: 8px; }
.registration-field input { display: block; width: 100%; min-height: 46px; font-size: 13px; }
.registration-field input[aria-invalid="true"] { border-color: #b91c1c; }
.registration-help, .registration-contact { font-size: 12px; line-height: 1.7; color: #67748e; margin: 20px 0; }
.registration-contact { text-align: center; font-size: 11px; }
.registration-submit { display: flex; align-items: center; gap: 9px; min-height: 46px; }
.registration-submit:disabled { opacity: .65; cursor: wait; }
.registration-error { margin-top: 7px; color: #b91c1c; font-size: 12px; }
.registration-success { margin-top: 22px; padding: 14px 16px; background: #e6f3f7; color: #006483; border: 1px solid #91ccdc; border-radius: 10px; font-size: 13px; line-height: 1.7; }
.registration-spinner { width: 16px; height: 16px; border: 2px solid rgb(255 255 255 / 40%); border-top-color: white; border-radius: 50%; animation: registration-spin .8s linear infinite; }
@keyframes registration-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .registration-spinner { animation: none; } }
@media (max-width: 640px) { .owner-registration h1 { font-size: 26px; } }
</style>